module.exports = __webpack_public_path__ + "img/21.f5979345.png";